import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLines, faTimes } from '@fortawesome/free-solid-svg-icons';
import whatsapp_icon from './assets/whatsapp_green.svg';
import LogoPlaceholder from '../LogoPlaceHolder';
import { Promoter } from '../../types/promoter';

interface HeaderProps {
    onBuyClick?: () => void;
    showGalleryLink?: boolean;
    showTourPlan?: boolean;
    showIncludes?: boolean;
    showDataTravel?: boolean;
    isOrderLoading?: boolean;
    handlePhoneClick?: () => void;
    flag?: string;
    labelButton?: string;
    stock: number;
    promoter: Promoter;
    loading: boolean;
    error: any;
    extraActions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
    onBuyClick,
    showGalleryLink = true,
    showTourPlan = true,
    showIncludes = true,
    showDataTravel = true,
    isOrderLoading,
    handlePhoneClick,
    flag,
    labelButton = "Reservar ahora",
    stock,
    promoter,
    loading,
    error,
    extraActions
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const headerRef = useRef<HTMLElement>(null);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        event.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -100; // Ajusta este valor según la altura de tu header
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    if (loading) return <p></p>;
    if (error) return <p></p>;

    return (
        <header className={`header ${isMenuOpen ? 'active' : ''}`} ref={headerRef}>
            <div className="menu-bar-pc">
                <a href="/home">
                    {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname} className="logo" /> : <LogoPlaceholder name={promoter.fullname} />}
                </a>

                <nav className="menu-principal">
                    {showDataTravel && <a className='li__header-desktop' href="#datatravel"
                        onClick={(e) => scrollToSection(e, 'datatravel')}>Información general</a>}
                    {showIncludes && <a className='li__header-desktop' href="#includes"
                        onClick={(e) => scrollToSection(e, 'includes')}>Overview</a>}
                    {showTourPlan && <a className='li__header-desktop' href="#tourplan"
                        onClick={(e) => scrollToSection(e, 'tourplan')}>Tour
                        Plan</a>}
                    {showGalleryLink && <a className='li__header-desktop' href="#gallery"
                        onClick={(e) => scrollToSection(e, 'gallery')}>Galería de Fotos</a>}
                    {extraActions}
                    <button className='nav__btn-comprar'
                        style={flag === "checkout-api" ? {} : { backgroundColor: "#46B479" }}
                        onClick={flag === "checkout-api" ?
                            stock > 0 ?
                                onBuyClick
                                : () => { }
                            : handlePhoneClick}
                        disabled={flag === "checkout-api" ? stock === 0 : false}
                    >
                        <div className='interior'>
                            {isOrderLoading ?
                                <div className='order-loader'></div> :
                                flag === "checkout-api" ? <span>{labelButton}</span> : <><span>Consultar</span><img
                                    className='wp_img' src={whatsapp_icon} alt='icono de whatsapp' /></>
                            }</div>

                    </button>
                </nav>
            </div>

            <div className={`menu-bar-movil ${isMenuOpen ? 'active' : ''}`}>
                <div className={'menu-bar-movil__wrapper'}>
                    <a href="/home" className="logo">
                        {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname}  /> : <LogoPlaceholder name={promoter.fullname} />}
                    </a>
                    {extraActions}
                    <div className="burger-menu" onClick={toggleMenu}>
                        <FontAwesomeIcon
                            icon={isMenuOpen ? faTimes : faGripLines}
                            className={isMenuOpen ? 'icon-close' : 'icon-open'}
                        />
                    </div>

                    <div className={`slideMenu ${isMenuOpen ? 'active' : ''}`}>
                        <nav className="menu-principal">
                            {showDataTravel && <a href="#datatravel" onClick={(e) => {
                                scrollToSection(e, 'datatravel');
                                closeMenu();
                            }}>Información general</a>}
                            {showIncludes && <a href="#includes" onClick={(e) => {
                                scrollToSection(e, 'includes');
                                closeMenu();
                            }}>Overview</a>}
                            {showTourPlan && <a href="#tourplan" onClick={(e) => {
                                scrollToSection(e, 'tourplan');
                                closeMenu();
                            }}>Tour Plan</a>}
                            {showGalleryLink && <a href="#gallery" onClick={(e) => {
                                scrollToSection(e, 'gallery');
                                closeMenu();
                            }}>Galería de Fotos</a>}
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header; 